var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrierUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_411_19",
    "data-name": "Component 411 \\u2013 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4625",
    "data-name": "Rectangle 4625",
    transform: "translate(28) rotate(90)",
    fill: "#fff",
    stroke: "#e5e5e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 27,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10096",
    "data-name": "Mask Group 10096",
    transform: "translate(8.308 8.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14002",
    "data-name": "Path 14002",
    d: "M14.118,14.25v2.5a1.252,1.252,0,0,1-1.252,1.252H4.1A1.252,1.252,0,0,1,2.85,16.754v-2.5",
    transform: "translate(-2.85 -6.738)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14003",
    "data-name": "Path 14003",
    d: "M0,0,3.13,3.13,6.26,0",
    transform: "translate(8.764 3.13) rotate(180)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    y1: 7.512,
    transform: "translate(5.634 7.512) rotate(180)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierUpload);
export default __webpack_public_path__ + "static/media/carrier-upload.6cd3c09e0185940e31b9a5ba6d36a55c.svg";
export { ForwardRef as ReactComponent };